export const GET_CUSTODY_REQUEST = "GET_CUSTODY_REQUEST";
export const GET_CUSTODY_SUCCESS = "GET_CUSTODY_SUCCESS";
export const GET_CUSTODY_FAILURE = "GET_CUSTODY_FAILURE";

export const GET_LOCATION_FROM_CUSTODY_REQUEST = "GET_LOCATION_FROM_CUSTODY_REQUEST";
export const GET_LOCATION_FROM_CUSTODY_SUCCESS = "GET_LOCATION_FROM_CUSTODY_SUCCESS";
export const GET_LOCATION_FROM_CUSTODY_FAILURE = "GET_LOCATION_FROM_CUSTODY_FAILURE";

export const GET_CUSTODY_FROM_REQUEST = "GET_CUSTODY_FROM_REQUEST";
export const GET_CUSTODY_FROM_SUCCESS = "GET_CUSTODY_FROM_SUCCESS";
export const GET_CUSTODY_FROM_FAILURE = "GET_CUSTODY_FROM_FAILURE";

export const GET_DELETE_CUSTODY_REQUEST = "GET_DELETE_CUSTODY_REQUEST";
export const GET_DELETE_CUSTODY_SUCCESS = "GET_DELETE_CUSTODY_SUCCESS";
export const GET_DELETE_CUSTODY_FAILURE = "GET_DELETE_CUSTODY_FAILURE";


export const CREATE_CUSTODY_REQUEST = "CREATE_CUSTODY_REQUEST";
export const CREATE_CUSTODY_SUCCESS = "CREATE_CUSTODY_SUCCESS";
export const CREATE_CUSTODY_FAILURE = "CREATE_CUSTODY_FAILURE";

export const EDIT_CUSTODY_REQUEST = "EDIT_CUSTODY_REQUEST";
export const EDIT_CUSTODY_SUCCESS = "EDIT_CUSTODY_SUCCESS";
export const EDIT_CUSTODY_FAILURE = "EDIT_CUSTODY_FAILURE";

export const GET_PO_NUMBER_REQUEST = "GET_PO_NUMBER_REQUEST";
export const GET_PO_NUMBER_SUCCESS = "GET_PO_NUMBER_SUCCESS";
export const GET_PO_NUMBER_FAILURE = "GET_PO_NUMBER_FAILURE";

export const UPLOAD_CUSTODY_REQUEST = "UPLOAD_CUSTODY_REQUEST";
export const UPLOAD_CUSTODY_SUCCESS = "UPLOAD_CUSTODY_SUCCESS"; 
export const UPLOAD_CUSTODY_FAILURE = "UPLOAD_CUSTODY_FAILURE";

export const UPLOAD_URL_REQUEST = "UPLOAD_URL_REQUEST";
export const UPLOAD_URL_SUCCESS = "UPLOAD_URL_SUCCESS"; 
export const UPLOAD_URL_FAILURE = "UPLOAD_URL_FAILURE";

export const GET_INSERT_PONUMBER_REQUEST = "GET_INSERT_PONUMBER_REQUEST";
export const GET_INSERT_PONUMBER_SUCCESS = "GET_INSERT_PONUMBER_SUCCESS"; 
export const GET_INSERT_PONUMBER_FAILURE = "GET_INSERT_PONUMBER_FAILURE";

export const GET_INSERT_PONUMBER_fg_REQUEST = "GET_INSERT_PONUMBER_fg_REQUEST";
export const GET_INSERT_PONUMBER_fg_SUCCESS = "GET_INSERT_PONUMBER_fg_SUCCESS"; 
export const GET_INSERT_PONUMBER_fg_FAILURE = "GET_INSERT_PONUMBER_fg_FAILURE";
